var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 17.9975,
    rx: 18,
    ry: 17.9975,
    fill: "#1B1D52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_9139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.75C15.495 18.75 16.5 17.745 16.5 16.5C16.5 15.255 15.495 14.25 14.25 14.25C13.005 14.25 12 15.255 12 16.5C12 17.745 13.005 18.75 14.25 18.75ZM23.25 14.25H18.75C17.925 14.25 17.25 14.925 17.25 15.75V19.5H11.25V13.5C11.25 13.0875 10.9125 12.75 10.5 12.75C10.0875 12.75 9.75 13.0875 9.75 13.5V23.25C9.75 23.6625 10.0875 24 10.5 24C10.9125 24 11.25 23.6625 11.25 23.25V21.75H24.75V23.25C24.75 23.6625 25.0875 24 25.5 24C25.9125 24 26.25 23.6625 26.25 23.25V17.25C26.25 15.5925 24.9075 14.25 23.25 14.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_9139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelIcon);
export default __webpack_public_path__ + "static/media/hotel_icon.c9a01fe1c92f71e074bda393500e8d40.svg";
export { ForwardRef as ReactComponent };